module.exports = __webpack_public_path__ + "static/media/HomeBackground.9fbfe2f1.jpg";